import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { AuthProvider } from './context/AuthContext';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Forbidden from './pages/Forbidden';
import AuthConfirm from './pages/AuthConfirm';
import LegalDocument from './pages/LegalDocument';
import { GlobalLoadingProvider } from './context/GlobalLoadingContext';
import { UISettingsProvider } from './context/UISettingsContext';

const Assessment = lazy(() => import('./pages/Assessment'));
const Results = lazy(() => import('./pages/Results'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminSubmissionDetails = lazy(() => import('./pages/AdminSubmissionDetails'));
const AuthGuard = lazy(() => import('./components/AuthGuard'));
const AdminGuard = lazy(() => import('./components/AdminGuard'));

export default function App() {
  return (
    <BrowserRouter>
      <UISettingsProvider>
        <GlobalLoadingProvider>
          <AuthProvider>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/forbidden" element={<Forbidden />} />
                <Route element={<MainLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Home />} />
                  <Route path="/auth/callback" element={<Home />} />
                  <Route path="/auth/confirm" element={<AuthConfirm />} />
                  <Route path="/terms" element={<LegalDocument />} />
                  <Route path="/privacy" element={<LegalDocument />} />

                  <Route element={<AuthGuard />}>
                    <Route path="/assessment" element={<Assessment />} />
                    <Route path="/results/:id" element={<Results />} />

                    <Route element={<AdminGuard />}>
                      <Route path="/admin" element={<AdminDashboard />} />
                      <Route path="/admin/submission/:id" element={<AdminSubmissionDetails />} />
                    </Route>
                  </Route>

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </Suspense>
          </AuthProvider>
        </GlobalLoadingProvider>
      </UISettingsProvider>
    </BrowserRouter>
  );
}
